import * as tslib_1 from "tslib";
import { AbstractMethodError, AssetBase } from "@awayjs/core";
var ShadowMapperBase = (function (_super) {
    tslib_1.__extends(ShadowMapperBase, _super);
    function ShadowMapperBase() {
        var _this = _super.apply(this, arguments) || this;
        _this._depthMapSize = 2048;
        _this._autoUpdateShadows = true;
        return _this;
    }
    Object.defineProperty(ShadowMapperBase.prototype, "autoUpdateShadows", {
        get: function () {
            return this._autoUpdateShadows;
        },
        set: function (value) {
            this._autoUpdateShadows = value;
        },
        enumerable: true,
        configurable: true
    });
    ShadowMapperBase.prototype.updateShadows = function () {
        this._iShadowsInvalid = true;
    };
    ShadowMapperBase.prototype.iSetDepthMap = function (depthMap) {
        if (this._depthMap && !this._explicitDepthMap)
            this._depthMap.dispose();
        this._depthMap = depthMap;
    };
    Object.defineProperty(ShadowMapperBase.prototype, "light", {
        get: function () {
            return this._light;
        },
        set: function (value) {
            this._light = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShadowMapperBase.prototype, "depthMap", {
        get: function () {
            if (!this._depthMap)
                this._depthMap = this._createDepthTexture();
            return this._depthMap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShadowMapperBase.prototype, "depthMapSize", {
        get: function () {
            return this._depthMapSize;
        },
        set: function (value) {
            if (value == this._depthMapSize)
                return;
            this._setDepthMapSize(value);
        },
        enumerable: true,
        configurable: true
    });
    ShadowMapperBase.prototype.dispose = function () {
        if (this._depthMap && !this._explicitDepthMap)
            this._depthMap.dispose();
        this._depthMap = null;
    };
    ShadowMapperBase.prototype._createDepthTexture = function () {
        throw new AbstractMethodError();
    };
    ShadowMapperBase.prototype.iRenderDepthMap = function (view, renderer) {
        this._iShadowsInvalid = false;
        this._updateDepthProjection(view.camera.projection);
        if (!this._depthMap)
            this._depthMap = this._createDepthTexture();
        this._drawDepthMap(view, this._depthMap, renderer);
    };
    ShadowMapperBase.prototype._updateDepthProjection = function (projection) {
        throw new AbstractMethodError();
    };
    ShadowMapperBase.prototype._drawDepthMap = function (view, target, renderer) {
        throw new AbstractMethodError();
    };
    ShadowMapperBase.prototype._setDepthMapSize = function (value) {
        this._depthMapSize = value;
        if (this._explicitDepthMap) {
            throw Error("Cannot set depth map size for the current renderer.");
        }
        else if (this._depthMap) {
            this._depthMap.dispose();
            this._depthMap = null;
        }
    };
    return ShadowMapperBase;
}(AssetBase));
export { ShadowMapperBase };



// WEBPACK FOOTER //
// ../dist/lib/shadowmappers/ShadowMapperBase.js